export const DeferTimerMessage = {
  StartCountdown: 'START_COUNTDOWN',
  ReturnCountdownValue: 'RETURN_COUNTDOWN_VALUE',
  StopCountdown: 'STOP_COUNTDOWN',
  ClearCountdown: 'CLEAR_COUNTDOWN',
};
